import React, { useContext, useEffect, useState } from 'react'
import "./auditcal.css"
import Select from 'react-select';
import { BsEye } from 'react-icons/bs';
import { ThemeProvider, createTheme } from "@mui/material";
import MaterialTable from 'material-table';
import Modal from "react-modal";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
  FaPlusSquare,
  FaCheck,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaTrash,
  FaEdit,
  FaFilter,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaMinus,
  FaSave,
  FaSearch,
  FaThList,
} from "react-icons/fa";
import { MdOutlineFileDownload } from "react-icons/md";
import { GET, POST, PUT } from '../../Common/HttpMethods/HttpMethods';
import { Url } from '../../../constants/ApiUrlConstants';
import { SlPencil } from 'react-icons/sl';
import SuccessModal from '../../Common/Popups/SuccessModal';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { contextData } from "../../../context/ContextProvider"
import FailModal from '../../Common/Popups/FailModal'
import { DownloadExcel } from '../../Common/ExcelDownload/DownloadExcel';
import { createTableIcons, customStyles, customStylesAuditee, CustomYearPicker, modalStyles, tableIcons } from '../../CommonCase/CommonFunctions';
import { tableHeaderStyle } from "../../CommonCase/CommonFunctions"

export const handleSessionExpClose = (navigate) => {
  sessionStorage.clear();
  navigate('/login');
}

export const handleCloseFailModel = (setOpenFailModal) => {
  setOpenFailModal(false);
}


export const ClearIndicator = (props) => {
  return <div />
}

export const handleOpenModal = (setSelectedOptions,setIsEdited,setIsOpenModal,setAddedAudit,setOpenSuccessModal,setSelectedOptionsError) => {
  setSelectedOptions({
    deptartmentTagMaster: {
      deptTagId: null,
      deptTag: ""
    },
    auditor: {
      staffId: null,
      firstName: "",
      lastName: "",
      fullName: "",
      emailId: null
    },
    auditee: {
      staffId: null,
      firstName: "",
      lastName: "",
      fullName: "",
      emailId: ""
    },
    startDate: null,
    closingDate: null,
    auditPeriod: ""
  });

  setIsEdited(false);
  setIsOpenModal(true);
  setAddedAudit(false);
  setOpenSuccessModal(false);
  setSelectedOptionsError({
    auditArea: null,
    AuditPeriod: null,
    Auditor: null,
    Auditee: null,
    startDate: null,
    endDate: null,
  });
};


export const handleCloseModal = (setIsOpenModal,setSelectedOptionsError) => {
  setIsOpenModal(false);
  setSelectedOptionsError({
    auditArea: null,
    AuditPeriod: null,
    Auditor: null,
    Auditee: null,
    startDate: null,
    endDate: null,
  });
};

export const handleDownloadExcel = (data, setLoading) => {
  setLoading(true);
  DownloadExcel(data?.deptartmentTagMaster?.deptTagId, data?.auditYear, data?.auditPeriod)
    .then(() => {
      setLoading(false);
    })
    .catch(() => {
      setLoading(false);
    });
};


export const getAuditYearFunc = async (token, setYearList) => {
  const getYear = await GET(Url?.getAuditYear, token);
  if (getYear?.SUCCESS) {
    let yearData = getYear?.DATA?.yearList?.map((i) => {
      return { label: i, value: i };
    });
    setYearList(yearData)
  }
}

export const getPeriodLabels = (auditPeriod) => {
  switch (auditPeriod) {
    case "Quarter 4":
      return "Q4 (Jan - Mar)";
    case "Quarter 1":
      return "Q1 (Apr - Jun)";
    case "Quarter 2":
      return "Q2 (Jul - Sep)";
    case "Quarter 3":
      return "Q3 (Oct - Dec)";
    default:
      return "";
  }
};

export const navigateAfterSubmit = (navigate) => {
  navigate("/main/audit/calendar");
}

export const handleNavigate = (data,navigate) => {

  let year = {
    label: data?.auditYear,
    value: data?.auditYear
  }

  let quarter = {
    label: data?.auditPeriod,
    value: data?.auditPeriod
  }

  let dept = {
    label: data?.deptartmentTagMaster.deptTag,
    value: data?.deptartmentTagMaster.deptTagId
  }

  navigate('/main/audit/observation', { state: { year, quarter, dept } });
}

export const getEmployeeData = async (setLoading, token, setAllEmployeeOptions, setSessionExpiredModal, setFailMessage, setOpenFailModal) => {
  try {
    setLoading(true);
    const getAllEmployee = await GET(Url.getEmployees, token);

    if (getAllEmployee.SUCCESS) {
      setLoading(false);
      const options = getAllEmployee?.DATA?.map((employee) => ({
        value: employee,
        label: employee.fullName,
      }));
      setAllEmployeeOptions(options)
    }
    else if (getAllEmployee.STATUS === 401) {
      setLoading(false)
      setSessionExpiredModal(true)
      setFailMessage("Session expired")
    }
    else if (getAllEmployee.STATUS === 400) {
      setLoading(false)
      setSessionExpiredModal(true)
      setFailMessage("Session expired")
    }
    else if (getAllEmployee.STATUS === 404) {
      setLoading(false)
      setSessionExpiredModal(true)
      setFailMessage("Session expired")
    }
    else if (getAllEmployee.STATUS === 403) {
      setLoading(false)
      setSessionExpiredModal(true)
      setFailMessage("Session expired")
    }
    else if (getAllEmployee.STATUS === 500) {
      setLoading(false)
      setSessionExpiredModal(true)
      setFailMessage("Session expired")
    }
    else {
      setLoading(false);
      setFailMessage("Failed to fetch Audit Table data.");
      setOpenFailModal(true);
    }

  } catch (error) {
    console.error('Error:', error);
    setOpenFailModal(true);
    setFailMessage("Failed to fetch Audit table data.");
  }
};


export const handleSelectChange = (name, value, setSelectedOptionsError, setSelectedOptions, getAllEmployeeOptions, setGetFilteredEmployees) => {
  switch (name) {
    case "deptartmentTagMaster":
      setSelectedOptionsError(prevState => ({
        ...prevState,
        auditArea: value ? null : "Required"
      }));
      setSelectedOptions(prevState => ({
        ...prevState,
        [name]: value ? { deptTagId: value.value, deptTag: value.label } : null
      }));
      break;
    case "auditPeriod":
      setSelectedOptionsError(prevState => ({
        ...prevState,
        AuditPeriod: value ? null : "Required"
      }));
      setSelectedOptions(prevState => ({
        ...prevState,
        [name]: value ? value.value : null
      }));
      break;
    case "auditor":
      setSelectedOptionsError(prevState => ({
        ...prevState,
        [name.charAt(0).toUpperCase() + name.slice(1)]: value && value.length > 0 ? null : "Required"
      }));
      setSelectedOptions(prevState => ({
        ...prevState,
        [name]: value ? value.map(item => item.value) : []
      }));
      const filteredAuditeeOptions = getAllEmployeeOptions.filter(option => {
        return !value?.some(selected => selected.value === option.value);
      });
      setGetFilteredEmployees(filteredAuditeeOptions)

      setSelectedOptions(prevState => ({
        ...prevState,
        auditeeOptions: filteredAuditeeOptions
      }));
      break;
    case "auditee":
      setSelectedOptionsError(prevState => ({
        ...prevState,
        [name.charAt(0).toUpperCase() + name.slice(1)]: value && value.length > 0 ? null : "Required"
      }));
      setSelectedOptions(prevState => ({
        ...prevState,
        [name]: value ? value.map(item => item.value) : []
      }));
      break;
    default:
      break;
  }
};


export const handleDateChange = (name, value, setSelectedOptionsError, setSelectedOptions) => {
  if (name !== "startDate" && name !== "closingDate") {
    console.error("Invalid date format");
    return;
  }

  setSelectedOptionsError(prevState => ({
    ...prevState,
    [name]: value ? null : "Required"
  }));

  setSelectedOptions(prevOptions => ({
    ...prevOptions,
    [name]: value
  }));
};


export const birthYearChange = (date, setBirthYearForCalender, setYear) => {
  setBirthYearForCalender(date);
  setYear(date.getFullYear());
};

export const updateData = async (selectedOptions, setSelectedOptionsError, setLoading, setIsOpenModal, setOpenSuccessModal, setSuccessMessage, setEditedAudit, setSessionExpiredModal, setFailMessage, setOpenFailModal, token) => {
  const parseISODateToArray = (isoDate) => {
    const date = new Date(isoDate);
    return [date.getFullYear(), date.getMonth() + 1, date.getDate()];
  };

  const modifiedBody = {
    "auditId": selectedOptions?.auditId,
    "deptartmentTagMaster": {
      "deptTagId": parseInt(selectedOptions?.deptartmentTagMaster?.deptTagId),
      "deptTag": selectedOptions?.deptartmentTagMaster?.deptTag
    },
    "auditor": selectedOptions?.auditor,
    "auditee": selectedOptions?.auditee,
    "startDate": parseISODateToArray(selectedOptions?.startDate),
    "closingDate": parseISODateToArray(selectedOptions?.closingDate),
    "auditPeriod": selectedOptions?.auditPeriod
  };

  setSelectedOptionsError({
    auditArea: null,
    AuditPeriod: null,
    Auditor: null,
    Auditee: null,
    startDate: null,
    endDate: null,
  });

  let hasError = false;

  if (!modifiedBody.deptartmentTagMaster || !modifiedBody.deptartmentTagMaster.deptTagId) {
    setSelectedOptionsError(prevState => ({ ...prevState, auditArea: "Required" }));
    hasError = true;
  }

  if (modifiedBody.auditPeriod === null) {
    setSelectedOptionsError(prevState => ({ ...prevState, AuditPeriod: "Required" }));
    hasError = true;
  }

  if (!Array.isArray(modifiedBody.auditee) || modifiedBody.auditee.length === 0) {
    setSelectedOptionsError(prevState => ({ ...prevState, Auditee: "Required" }));
    hasError = true;
  }

  if (!Array.isArray(modifiedBody.auditor) || modifiedBody.auditor.length === 0) {
    setSelectedOptionsError(prevState => ({ ...prevState, Auditor: "Required" }));
    hasError = true;
  }

  if (modifiedBody.startDate === null) {
    setSelectedOptionsError(prevState => ({ ...prevState, startDate: "Required" }));
    hasError = true;
  }

  if (modifiedBody.closingDate === null) {
    setSelectedOptionsError(prevState => ({ ...prevState, endDate: "Required" }));
    hasError = true;
  }

  if (hasError) {
    return;
  }

  setLoading(true)

  try {
    const PostUpdateData = await PUT(Url?.updateAuditCalendar, token, modifiedBody);

    if (PostUpdateData.SUCCESS) {
      setIsOpenModal(false);
      setLoading(false)
      setOpenSuccessModal(true)
      setSuccessMessage("Audit Edited Successfully")
      setEditedAudit(true)
    } else if (PostUpdateData.STATUS === 401) {
      setSessionExpiredModal(true)
      setFailMessage("Session expired")
    } else if (PostUpdateData.STATUS === 400) {
      setSessionExpiredModal(true)
      setFailMessage("The request was invalid.")
    }else if (PostUpdateData.STATUS === 403) {
      setSessionExpiredModal(true)
      setFailMessage("You do not have access.")
    }else if (PostUpdateData.STATUS === 404) {
      setSessionExpiredModal(true)
      setFailMessage("The resource could not be found.")
    }else if (PostUpdateData.STATUS === 500) {
      setSessionExpiredModal(true)
      setFailMessage("Something went wrong on the server")
    }else {
      console.error('Update operation failed:', PostUpdateData.error);
      setFailMessage("Failed to Edit Audit.");
      setOpenFailModal(true);
      setLoading(false)
    }
  } catch (error) {
    console.error('Error occurred during update:', error);
    setFailMessage("Failed to Edit Audit.");
    setOpenFailModal(true);
    setLoading(false)
  }
};

export const handleSubmit = async (selectedOptions, setSelectedOptionsError, setLoading, setOpenSuccessModal, setSuccessMessage, setIsOpenModal, setAddedAudit, setOpenFailModal, setFailMessage, setSessionExpiredModal, token) => {
  const parseISODateToArray = (isoDate) => {
    const date = new Date(isoDate);
    return [date.getFullYear(), date.getMonth() + 1, date.getDate()];
  };

  const startDate = selectedOptions.startDate ? parseISODateToArray(selectedOptions.startDate) : null;
  const closingDate = selectedOptions.closingDate ? parseISODateToArray(selectedOptions.closingDate) : null;

  const FinalPostBody = {
    "deptartmentTagMaster": {
      "deptTagId": selectedOptions.deptartmentTagMaster?.deptTagId ? parseInt(selectedOptions.deptartmentTagMaster.deptTagId) : null,
      "deptTag": selectedOptions.deptartmentTagMaster?.deptTag || null
    },
    "auditor": Array.isArray(selectedOptions.auditor) ?
      selectedOptions.auditor.map((auditor) => ({
        "staffId": auditor?.staffId || null,
        "firstName": auditor?.firstName || null,
        "lastName": auditor?.lastName || null,
        "fullName": auditor?.fullName || null,
        "emailId": auditor?.emailId || null
      })).filter(Boolean) : [],
    "auditee": Array.isArray(selectedOptions.auditee) ?
      selectedOptions.auditee.map((auditee) => ({
        "staffId": auditee?.staffId || null,
        "firstName": auditee?.firstName || null,
        "lastName": auditee?.lastName || null,
        "fullName": auditee?.fullName || null,
        "emailId": auditee?.emailId || null
      })).filter(Boolean) : [],
    "auditYear": startDate ? startDate[0] : null,
    "startDate": startDate,
    "closingDate": closingDate,
    "auditPeriod": selectedOptions.auditPeriod || null
  };

  setSelectedOptionsError({
    auditArea: null,
    AuditPeriod: null,
    Auditor: null,
    Auditee: null,
    startDate: null,
    endDate: null,
  });

  let hasError = false;

  if (!FinalPostBody.deptartmentTagMaster || !FinalPostBody.deptartmentTagMaster.deptTagId) {
    setSelectedOptionsError(prevState => ({ ...prevState, auditArea: "Required" }));
    hasError = true;
  }

  if (FinalPostBody.auditPeriod === null) {
    setSelectedOptionsError(prevState => ({ ...prevState, AuditPeriod: "Required" }));
    hasError = true;
  }

  if (!Array.isArray(FinalPostBody.auditee) || FinalPostBody.auditee.length === 0) {
    setSelectedOptionsError(prevState => ({ ...prevState, Auditee: "Required" }));
    hasError = true;
  }

  if (!Array.isArray(FinalPostBody.auditor) || FinalPostBody.auditor.length === 0) {
    setSelectedOptionsError(prevState => ({ ...prevState, Auditor: "Required" }));
    hasError = true;
  }

  if (FinalPostBody.startDate === null) {
    setSelectedOptionsError(prevState => ({ ...prevState, startDate: "Required" }));
    hasError = true;
  }

  if (FinalPostBody.closingDate === null) {
    setSelectedOptionsError(prevState => ({ ...prevState, endDate: "Required" }));
    hasError = true;
  }

  if (hasError) {
    return;
  }

  setLoading(true)

  try {
    const postAudit = await POST(Url.saveAuditCalendar, token, FinalPostBody);
    if (postAudit.SUCCESS) {
      if (postAudit.MESSAGE == "Audit Added Successfully") {
        setOpenSuccessModal(true)
        setSuccessMessage(postAudit.MESSAGE)
        setIsOpenModal(false);
        setAddedAudit(true)
        setLoading(false)
      } else {
        setOpenFailModal(true)
        setFailMessage("Audit Year and Audit Quarter Already Exist!")
        setIsOpenModal(false);
        setLoading(false)
      }
    } else if (postAudit.STATUS === 401) {
      setSessionExpiredModal(true)
      setFailMessage("Session expired")
      setLoading(false)
    } else if (postAudit.STATUS === 400) {
      setSessionExpiredModal(true)
      setFailMessage("The request was invalid.")
    }else if (postAudit.STATUS === 403) {
      setSessionExpiredModal(true)
      setFailMessage("You do not have access.")
    }else if (postAudit.STATUS === 404) {
      setSessionExpiredModal(true)
      setFailMessage("The resource could not be found.")
    }else if (postAudit.STATUS === 500) {
      setSessionExpiredModal(true)
      setFailMessage("Something went wrong on the server")
    }else {
      setFailMessage("Failed to add Audit.");
      setOpenFailModal(true);
      setLoading(false)
    }
  } catch (error) {
    console.error('Error posting audit:', error);
    setFailMessage("Failed to add Audit.");
    setOpenFailModal(true);
    setLoading(false)
  }
};


export const handleEditClick = async (rowData, setEditedAudit, setIsEdited, setIsOpenModal, token, setSelectedOptions) => {
  // First set state before making the GET request
  setEditedAudit(false);
  setIsEdited(true);
  setIsOpenModal(true);

  try {
    const getEditData = await GET(Url?.getAuditCalendarByAuditId.replace("{auditId}", rowData?.auditId), token);
    const editExtracted = getEditData.DATA;

    const startDate = Array.isArray(editExtracted.startDate)
      ? new Date(editExtracted.startDate[0], editExtracted.startDate[1] - 1, editExtracted.startDate[2])
      : null;
    const closingDate = Array.isArray(editExtracted.closingDate)
      ? new Date(editExtracted.closingDate[0], editExtracted.closingDate[1] - 1, editExtracted.closingDate[2])
      : null;

    // Call setSelectedOptions directly with the object
    setSelectedOptions({
      auditId: editExtracted.auditId,
      deptartmentTagMaster: editExtracted.deptartmentTagMaster,
      auditor: editExtracted.auditor,
      auditee: editExtracted.auditee,
      startDate: startDate,
      closingDate: closingDate,
      auditPeriod: editExtracted.auditPeriod
    });
  } catch (error) {
    console.error("Failed to fetch data", error);
    // Handle error logic if needed
  }
};

export const getAuditTableData = async ({
  GET,
  urlTemplate,
  dept,
  year,
  token,
  setAuditCalendarData,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
}) => {
  const url = urlTemplate.replace("{deptId}", dept?.value).replace("{year}", year);

  try {
    const getAuditCalendarData = await GET(url, token);
    if (getAuditCalendarData.SUCCESS) {
      const IndexedData = getAuditCalendarData?.DATA?.map((i, ind) => {
        return { ...i, index: ind + 1 };
      });
      setAuditCalendarData(IndexedData);
    } else if (getAuditCalendarData.STATUS === 401) {
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (getAuditCalendarData.STATUS === 400) {
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else if (getAuditCalendarData.STATUS === 403) {
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else if (getAuditCalendarData.STATUS === 404) {
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else if (getAuditCalendarData.STATUS === 500) {
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }  else {
      setFailMessage("Failed to fetch Audit Table data.");
      setOpenFailModal(true);
    }
  } catch (error) {
    console.error("Error fetching audit table data:", error);
    setOpenFailModal(true);
    setFailMessage("Failed to fetch Audit table data.");
  }
};

const AuditCal = () => {
  const theme = createTheme();

  const { setLoading } = useContext(contextData)

  const navigate = useNavigate()

  let d = new Date()

  const tableIcons = createTableIcons()

  const [dept, setDept] = useState({
    label: "All",
    value: 0,
  });

  // const [year, setYear] = useState({
  //   label: `${d.getFullYear()}`,
  //   value: `${d.getFullYear()}`,
  // });

  const [year, setYear] = useState(d.getFullYear());

  const [addedAudit, setAddedAudit] = useState(false)
  const [editedAudit, setEditedAudit] = useState(false)
  const [openFailModal, setOpenFailModal] = useState(false);

  const [auditData, setAuditData] = useState({
    latestDepartTag: "",
    latestQuarter: "",
    latestYear: ""
  })



  // useEffect(() => {
  //   getAuditTableData()
  //   getAuditYearFunc()
  // }, [addedAudit])


  // useEffect(() => {
  //   getAuditTableData()
  // }, [year, dept])


  // useEffect(() => {
  //   getAuditTableData()
  //   getAuditYearFunc()
  // }, [editedAudit])

  useEffect(() => {
    getAuditTableData({
      GET,
      urlTemplate: Url.getAuditCalendarDataByDeptIdAndYear,
      dept,
      year,
      token,
      setAuditCalendarData,
      setSessionExpiredModal,
      setFailMessage,
      setOpenFailModal,
    });

    if (addedAudit || editedAudit) {
      getAuditYearFunc(token, setYearList);
    }
  }, [addedAudit, year, dept, editedAudit]);




  const [isOpenModal, setIsOpenModal] = useState(false);
  const [yearList, setYearList] = useState([])
  const [selectedOptions, setSelectedOptions] = useState({
    deptartmentTagMaster: {
      deptTagId: null,
      deptTag: ""
    },
    auditor: {
      staffId: null,
      firstName: "",
      lastName: "",
      fullName: "",
      emailId: null
    },
    auditee: {
      staffId: null,
      firstName: "",
      lastName: "",
      fullName: "",
      emailId: ""
    },
    startDate: null,
    closingDate: null,
    auditPeriod: "",
  });



  const [selectedOptionsError, setSelectedOptionsError] = useState({
    auditArea: null,
    AuditPeriod: null,
    Auditor: null,
    Auditee: null,
    startDate: null,
    endDate: null,
  });



  const [auditCalendarData, setAuditCalendarData] = useState([])


  const [getAllEmployeeOptions, setAllEmployeeOptions] = useState([]);
  const [getFilteredEmployees, setGetFilteredEmployees] = useState([])


  // const handleSessionExpClose = () => {
  //   sessionStorage.clear();
  //   navigate('/login');
  // }

  // const handleCloseFailModel = () => {
  //   setOpenFailModal(false);
  // }


  // const ClearIndicator = (props) => {
  //   return <div />
  // }

  const token = sessionStorage.getItem("TOKEN");


  useEffect(() => {
    getEmployeeData(setLoading, token, setAllEmployeeOptions, setSessionExpiredModal, setFailMessage, setOpenFailModal);
  }, [dept, year]);


  const [isEdited, setIsEdited] = useState(false)
  // ==============================================================================Create Audit(popup) operations================================================================
  const auditAreaOptions = [
    { value: '1', label: 'HR Department' },
    { value: '2', label: 'Governance Department' },
    { value: '3', label: 'IT Department' },
    { value: '4', label: 'Facility Department' },
  ];

  const [openSuccessModal, setOpenSuccessModal] = useState(false)
  const [successMessage, setSuccessMessage] = useState("")
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false)
  const [failMessage, setFailMessage] = useState("");

  const auditPeriodOptions = [

    { value: 'Quarter 1', label: 'Q1 (April - June)' },
    { value: 'Quarter 2', label: 'Q2 (July - September)' },
    { value: 'Quarter 3', label: 'Q3 (October - December)' },
    { value: 'Quarter 4', label: 'Q4 (January - March)' },
  ];


  // ========================================================================API Integration==========================================================================


  useEffect(() => {
    getYear()
  }, [])

  const getYear = async () => {
    try {
      const getYear = await GET(Url?.getAuditYear, token);
      if (getYear.SUCCESS) {

        setAuditData({
          ...auditData,
          latestYear: getYear?.DATA?.latestYear,
          latestQuarter: getYear?.DATA?.latestQuarter,
          latestDepartTag: getYear?.DATA?.latestDepartTag
        })

      } else if (getYear?.STATUS == 401) {
        setLoading(false);
        setSessionExpiredModal(true);
        setFailMessage("Session expired");
      }
    } catch (error) {
      setLoading(false);

    }
  }

  let options = [
    {
      label: "All",
      value: 0,
    },
    {
      label: "HR",
      value: 1,
    },
    {
      label: "Governance",
      value: 2,
    },
    {
      label: "IT",
      value: 3,
    },
    {
      label: "Facillity",
      value: 4,
    },
  ];


  const [birthYearForCalender, setBirthYearForCalender] = useState(new Date());




  const columns = [
    {
      title: <p style={{ padding: "2px 0px" }}>SR. NO.</p>,
      field: "SrNo",
      sorting: false,
      render: (rowData) => {
        return (
          <div
            className="auditcal-table-row-data" style={{ textAlign: "right" }}
          >
            {rowData.index}
          </div>
        );
      },
    },
    {
      title: <p style={{ padding: "2px 0px" }}>DEPARTMENT</p>,
      field: "deptartmentTagMaster?.deptTag",
      sorting: false,
      render: (rowData) => {
        return (
          <div
            style={{ position: "relative" }}
            className="auditcal-table-row-data"
          >
            <div style={{}}>{rowData?.deptartmentTagMaster?.deptTag}</div>
            {rowData?.deptartmentTagMaster?.deptTag && (
              <div className="cref-number-tooltip-checklist">
                {rowData?.deptartmentTagMaster?.deptTag ? rowData?.deptartmentTagMaster?.deptTag : "N/A"}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: <p>AUDITOR</p>,
      field: "auditor.fullName",
      sorting: false,
      render: (rowData) => {
        return (
          <div className="auditcal-table-row-data Audit-auditor-list-row" style={{ position: 'relative' }}>
            {rowData?.auditor && Array.isArray(rowData.auditor) && rowData.auditor.length > 0 ? (
              <div style={{
                overflow: "hidden", textOverflow: "ellipsis", textWrap: "nowrap",
                width: '221px'
              }}>
                {rowData.auditor.map((staff, index) => (
                  <span key={index}>
                    {`${staff.firstName} ${staff.lastName}${index !== rowData.auditor.length - 1 ? "; " : ""}`}
                  </span>
                ))}
              </div>

            ) : (
              "N/A"
            )}
            {rowData?.auditor && Array.isArray(rowData.auditor) && rowData.auditor.length > 0 &&
              <div className='auditorlist-tool-tip1'
              // style={{ overflow: "hidden",textOverflow: "ellipsis",textWrap: "nowrap",
              // width:'221px'}}
              >
                {rowData.auditor.map((staff, index) => (
                  <span key={index}>
                    {`${staff.firstName} ${staff.lastName}${index !== rowData.auditor.length - 1 ? "; " : ""}`}
                  </span>
                ))}
              </div>
            }
          </div>
        );
      },
    },


    {
      title: <p>AUDITEE</p>,
      field: "auditee.fullName",
      sorting: false,
      render: (rowData) => {
        return (
          <div className="auditcal-table-row-data Audit-auditee-list-row" style={{ position: 'relative' }}>
            {rowData?.auditee && Array.isArray(rowData.auditee) && rowData.auditee.length > 0 ? (
              <div style={{
                overflow: "hidden", textOverflow: "ellipsis", textWrap: "nowrap",
                width: '221px'
              }} >
                {rowData.auditee.map((staff, index) => (
                  <span key={index}>
                    {`${staff.firstName} ${staff.lastName}${index !== rowData.auditee.length - 1 ? ";" : ""}`}
                  </span>
                ))}
              </div>
            ) : (
              "N/A"
            )}
            {rowData?.auditee && Array.isArray(rowData.auditee) && rowData.auditee.length > 0 &&
              <div className='auditeelist-tool-tip1'
              // style={{ overflow: "hidden",textOverflow: "ellipsis",textWrap: "nowrap",
              // width:'221px'}}
              >
                {rowData.auditee.map((staff, index) => (
                  <span key={index}>
                    {`${staff.firstName} ${staff.lastName}${index !== rowData.auditee.length - 1 ? ";" : ""}`}
                  </span>
                ))}
              </div>
            }
          </div>

        );
      },
    },


    {
      title: <p>START DATE</p>,
      field: "startDate",
      sorting: false,
      render: (rowData) => {

        const [year, month, day] = rowData?.startDate;
        const formattedDate = moment([year, month - 1, day]).format("DD-MMM-YYYY");
        return (
          <div className="auditcal-table-row-data">
            {formattedDate}
          </div>
        );
      },
    },

    {
      title: <p>CLOSING DATE</p>,
      field: "closingDate",
      sorting: false,
      render: (rowData) => {
        const [year, month, day] = rowData?.closingDate;
        const formattedDate = moment([year, month - 1, day]).format("DD-MMM-YYYY");
        return (
          <div className="auditcal-table-row-data">
            {formattedDate}
          </div>
        );
      },

    },
    {
      title: <p>PERIOD</p>,
      field: "period",
      sorting: false,
      render: (rowData) => {
        const periodLabels = getPeriodLabels(rowData?.auditPeriod);
        return (
          <div className="auditcal-table-row-data">
            {periodLabels}
          </div>
        );
      },

    },
    {
      title: <p>ACTION</p>,
      field: 'action',
      sorting: false,
      render: (rowData) => {
        return (
          <div style={{ cursor: 'pointer', display: 'flex', alignItems: "center", justifyContent: "center", width: "100%" }} className="auditcal-table-row-data">
            <span style={{ display: 'flex', alignItems: "center", justifyContent: "space-evenly", width: "100%" }}>
              <button className="AuditActionbutton" onClick={() => handleEditClick(rowData, setEditedAudit, setIsEdited, setIsOpenModal, token, setSelectedOptions)}>
                <SlPencil size={12} />
                {/* <span className="TooltipText">Edit</span> */}
              </button>
              <button className="AuditActionbutton" onClick={() => handleNavigate(rowData,navigate)}>
                <BsEye size={14} />
                {/* <span className="TooltipText">VIew</span> */}
              </button>
              <button className="AuditActionbutton" onClick={() => handleDownloadExcel(rowData, setLoading)}>

                <MdOutlineFileDownload size={18} />
                {/* <span style={{ left: "5%" }} className="TooltipText">Donwload</span> */}
              </button>
            </span>
          </div>

        );
      },
    },

  ];

  return (
    <div className='auditcal-main-div' >
      <div className="auditcal-uitility-container">
        <div className="auditcal-dept-selector">

          <span >Year &nbsp; </span>
          <CustomYearPicker
            selectedDate={birthYearForCalender}
            // onDateChange={() => birthYearChange(setBirthYearForCalender, setYear)}
            onDateChange={(date) => {
              const parsedDate = new Date(date);
              birthYearChange(parsedDate, setBirthYearForCalender, setYear);
            }}
          />
          <label style={{ marginLeft: 15, marginRight: 10 }} htmlFor='DepartmentSelect'>Department</label>
          <Select
            inputId='DepartmentSelect'
            aria-label="Department"
            data-testid='DepartmentSelect'
            isSearchable={false}
            options={options}
            styles={customStyles}
            value={dept}
            onChange={(e) => {
              setDept(e);
            }}
          />

        </div>
        <div className="Auditcal-searchbar-cont">
          {/* <div className="auditcal-serchbox">
            <BsSearch fill="#999999" />
            <input
              type="text"
              placeholder="Search"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
          </div> */}
          <div className='create-audit-btn' data-testid='Create-Audit_Btn-testId' onClick={()=>handleOpenModal(setSelectedOptions,setIsEdited,setIsOpenModal,setAddedAudit,setOpenSuccessModal,setSelectedOptionsError)} >
            Create Audit
          </div>
        </div>
      </div>
      <div className='auditcal-table-container'>
        <ThemeProvider theme={theme}>
          <MaterialTable
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <span className="no_data_found_table">No Audit Scheduled</span>
                ),
              },
            }}
            data={auditCalendarData}
            // style={{ overflowX: "hidden" }}
            columns={columns}
            icons={tableIcons}
            options={{
              toolbar: false,
              search: false,
              draggable: false,
              pageSizeOptions: [5, 10, 15, 20],
              pageSize: 10,
              zIndex: 0,
              headerStyle: {
                position: "sticky",
                top: -1,
                ...tableHeaderStyle,
              },
              maxBodyHeight: "66vh",
              minBodyHeight: "66vh",

            }}
          />
        </ThemeProvider>
      </div>
      <Modal
        isOpen={isOpenModal}
        style={modalStyles}
        // onRequestClose={handleCloseModal}
        contentLabel="Example Modal"
      >

        <div className="create-Internal-modal">
          <div className="tb-modal-close-btn" onClick={()=>handleCloseModal(setIsOpenModal,setSelectedOptionsError)}><span>X</span></div>

          <div className='Audit-modal-info-cont'>
            <div className='Audit-modal-info-row1'>
              <div className='Audit-modal-header-container tb-modal-header' style={{ position: "relative", textAlign: 'center' }}>
                <h4 id='MeetingSub_div' style={{ paddingBottom: '10px' }}  > Setup Internal Audit</h4>
              </div>

            </div>
            <div className='Audit-row-twoo-Cont'>
              <div className='Audit-names-cont' >
                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '13px' }}>
                  <div style={{}} className='Audit-area-period-conts'>
                    <div style={{ width: '48%', textAlign: 'center', paddingBottom: '3px', marginLeft: "-6px !important", display: 'flex', justifyContent: 'space-between' }} >
                      <label htmlFor='AuditArea' style={{ whiteSpace: "nowrap", display: "flex", width: "100%", justifyContent: "space-between" }}>Audit Area<span style={{ color: 'red' }}>*</span><span style={{ paddingLeft: '15px' }}>:</span></label></div>
                    <Select
                      options={auditAreaOptions}
                      placeholderText="Select Area"
                      value={selectedOptions?.deptartmentTagMaster.deptTagId ? {
                        label: selectedOptions.deptartmentTagMaster.deptTag,
                        value: selectedOptions.deptartmentTagMaster.deptTagId
                      } : null}
                      styles={customStyles}
                      onChange={(selectedOption) => handleSelectChange('deptartmentTagMaster', selectedOption, setSelectedOptionsError, setSelectedOptions, getAllEmployeeOptions, setGetFilteredEmployees)}
                      className='AuditorSelectDrop'
                      isDisabled={isEdited}
                      data-testid="AuditorSelectDrop"
                    />

                  </div>

                  {selectedOptionsError.auditArea && (
                    <span className='errorMessage' style={{ color: 'red', paddingLeft: "103px" }}>{selectedOptionsError.auditArea}</span>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
                  <div style={{}} className='Audit-area-period-conts'>
                    <div style={{ paddingRight: "0px", width: '55%', paddingBottom: '3px', display: 'flex', justifyContent: 'space-between' }}>
                      <label htmlFor='AuditPeriod' style={{ whiteSpace: "nowrap", display: "flex", width: "100%", justifyContent: "space-between" }}>Audit Period<span style={{ color: 'red' }}>*</span>  <span style={{ paddingLeft: ' 3px' }}>:</span></label>
                    </div>


                    <Select
                      value={selectedOptions?.auditPeriod ? {
                        label: selectedOptions.auditPeriod,
                        value: selectedOptions.auditPeriod
                      } : null}
                      onChange={(selectedOption) => handleSelectChange('auditPeriod', selectedOption, setSelectedOptionsError, setSelectedOptions, getAllEmployeeOptions, setGetFilteredEmployees)}
                      options={auditPeriodOptions}
                      errorColor={selectedOptionsError.selectedOption3 ? 'red' : 'gray'}
                      styles={customStyles}
                      className='AuditorSelectDrop'
                      isDisabled={isEdited}
                      data-testid="auditPeriod"
                    />




                  </div>
                  {selectedOptionsError.AuditPeriod && (
                    <div className='errorMessage' style={{ color: 'red', paddingLeft: "103px" }}>{selectedOptionsError?.AuditPeriod}</div>
                  )}
                </div>

              </div>
              <div className='Audit-names-cont'>
                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '13px' }}>
                  <div className='Audit-area-period-conts'>
                    <div style={{ width: '44%', paddingBottom: '3px' }}>
                      <label htmlFor="openingDate" style={{ whiteSpace: "nowrap" }}>Opening Date<span style={{ color: 'red' }}>*</span></label>
                      <span style={{ paddingLeft: ' 20px' }}>:</span>
                    </div>
                    <div className='Audit-modal-datepicker'>
                      <span style={{ marginRight: "12px", display: "flex", marginLeft: '5px', }}>
                        <svg
                          id="calendar-line-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="19.119px"
                          height="24.122px"
                          viewBox="0 0 27.119 27.122"
                        >
                          <path
                            id="Path_15922"
                            data-name="Path 15922"
                            d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z"
                            fill="gray"
                          />
                        </svg>
                      </span>

                      <DatePicker id='OpenDatePicker'
                        selected={selectedOptions?.startDate}
                        onChange={(date) => handleDateChange('startDate', date, setSelectedOptionsError, setSelectedOptions)}
                        dateFormat='dd/MM/yyyy'
                        placeholderText='Opening Date'
                        value={selectedOptions?.startDate}
                        minDate={new Date()}
                        disabled={isEdited}
                        popperProps={{ strategy: 'fixed' }}
                      // onKeyDown={(e) => {
                      //   e.preventDefault();
                      // }}
                      />
                    </div>

                  </div>
                  {selectedOptionsError.startDate && (
                    <div className='errorMessage' style={{ color: 'red', marginLeft: "120px" }}>{selectedOptionsError?.startDate}</div>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '13px' }}>
                  <div className='Audit-area-period-conts'>
                    <div style={{ width: '44%', paddingBottom: '3px' }}>
                      <label htmlFor="openingDate" style={{ whiteSpace: "nowrap" }} >Closing Date<span style={{ color: 'red' }}>*</span></label>
                      <span style={{ paddingLeft: '28px' }}>:</span>
                    </div>

                    <div style={{ backgroundColor: !selectedOptions?.startDate ? "rgb(230 230 230)" : "" }} className='Audit-modal-datepicker'>
                      <span style={{ marginRight: "12px", display: "flex", marginLeft: '5px', }}>
                        <svg
                          id="calendar-line-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="19.119px"
                          height="24.122px"
                          viewBox="0 0 27.119 27.122"
                        >
                          <path
                            id="Path_15922"
                            data-name="Path 15922"
                            d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z"
                            fill="gray"
                          />
                        </svg>
                      </span>
                      <DatePicker 
                      data-testid="closingDate"
                      id='endDatePicker'
                        selected={selectedOptions?.closingDate}
                        onChange={(date) => handleDateChange('closingDate', date, setSelectedOptionsError, setSelectedOptions)}
                        dateFormat='dd/MM/yyyy'
                        placeholderText='Closing Date'
                        value={selectedOptions?.closingDate}
                        minDate={selectedOptions?.startDate}
                        disabled={!selectedOptions?.startDate}
                        popperProps={{ strategy: 'fixed' }}
                      // onKeyDown={(e) => {
                      //   e.preventDefault();
                      // }}
                      />
                    </div>

                  </div>
                  {selectedOptionsError.endDate && (
                    <div className='errorMessage' style={{ color: 'red', marginLeft: "121px" }}>{selectedOptionsError?.endDate}</div>
                  )}
                </div>
              </div>
            </div>

            <div className='Audit-row-three-Cont'>
              <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
                <div className='Audit-area-period-conts '>
                  <div style={{ width: "18.7%" }}>
                    <label htmlFor='Auditor' >Auditor<span style={{ color: 'red' }}>*</span></label>
                    <span style={{ paddingLeft: '36px' }}>:</span>
                  </div>
                  <Select
                    value={selectedOptions?.auditor && selectedOptions.auditor.length > 0 ?
                      selectedOptions.auditor.map(auditor => ({
                        label: `${auditor.firstName} ${auditor.lastName}`,
                        value: auditor
                      })) : null}
                    onChange={(opt) => handleSelectChange('auditor', opt, setSelectedOptionsError, setSelectedOptions, getAllEmployeeOptions, setGetFilteredEmployees)}
                    options={getAllEmployeeOptions}
                    className='AuditorSelectDrop'
                    styles={customStylesAuditee}
                    isMulti={true}
                    // menuPortalTarget={menuPortalTargetRef.current}
                    // isDisabled={isEdited}
                    data-testid="auditor"
                    components={{ ClearIndicator }}
                  />

                </div>
                {selectedOptionsError.Auditor && (
                  <div className='errorMessage' style={{ color: 'red', marginLeft: "105px" }}>{selectedOptionsError?.Auditor}</div>
                )}
              </div>

              {
              }
              <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
                <div className='Audit-area-period-conts AuditInp'>
                  <div style={{ width: "18.7%" }}>
                    <label htmlFor='Auditor' >Auditee<span style={{ color: 'red' }}>*</span></label>
                    <span style={{ paddingLeft: '34px' }}>:</span>
                  </div>
                  <Select
                    value={selectedOptions?.auditee && selectedOptions.auditee.length > 0 ?
                      selectedOptions.auditee.map(auditee => ({
                        label: `${auditee.firstName} ${auditee.lastName}`,
                        value: auditee
                      })) : null}
                    onChange={(selectedOption) => handleSelectChange('auditee', selectedOption, setSelectedOptionsError, setSelectedOptions, getAllEmployeeOptions, setGetFilteredEmployees)}
                    options={isEdited ? getAllEmployeeOptions?.filter((item) => {
                      if (Array.isArray(selectedOptions?.auditor)) {
                        return !selectedOptions?.auditor?.some((row) => row?.staffId == item?.value?.staffId) && item;
                      }
                    }) : getFilteredEmployees}
                    className='AuditorSelectDrop'
                    styles={customStylesAuditee}
                    data-testid="auditee"
                    isMulti={true}

                    components={{ ClearIndicator }}
                  />

                </div>
                {selectedOptionsError.Auditee && (
                  <div className='errorMessage' style={{ color: 'red', marginLeft: "105px" }}>{selectedOptionsError?.Auditee}</div>
                )}

              </div>



              <div className="task-modal-ok-btn">
                <button data-testid="taskmodal"
                  onClick={
                    isEdited
                      ? () => updateData(
                        selectedOptions,
                        setSelectedOptionsError,
                        setLoading,
                        setIsOpenModal,
                        setOpenSuccessModal,
                        setSuccessMessage,
                        setEditedAudit,
                        setSessionExpiredModal,
                        setFailMessage,
                        setOpenFailModal,
                        token
                      )
                       : () =>handleSubmit(selectedOptions, setSelectedOptionsError, setLoading, setOpenSuccessModal, setSuccessMessage, setIsOpenModal, setAddedAudit, setOpenFailModal, setFailMessage, setSessionExpiredModal, token)
                  }
                >
                  {isEdited ? "Edit & Publish" : "Publish & notify"}
                </button>
              </div>
            </div>
          </div>
        </div>

      </Modal>

      <SuccessModal
        openSuccessModal={openSuccessModal}
        setOpenSuccessModal={setOpenSuccessModal}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        recallFunctionOnOk={()=>navigateAfterSubmit(navigate)}
        recallFunctionOnClose={()=>navigateAfterSubmit(navigate)}
      />

      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={()=>handleSessionExpClose(navigate)}
        recallFunctiononClose={()=>handleSessionExpClose(navigate)}
      />
      <FailModal
        openFailModal={openFailModal}
        setOpenFailModal={setOpenFailModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={()=>handleCloseFailModel(setOpenFailModal)}
        recallFunctiononClose={()=>handleCloseFailModel(setOpenFailModal)}
      />

    </div >

  )
}

export default AuditCal